const mobileMaxWidth = 767;
const hirePathname = "/nexus/hire-us";
const portfolioPathname = "/portfolio";
const ragPathname = "/langchain/retrieval-augmented-generation";
const langgraphPathname = "/langgraph/perplexity-chatbot";
const aiAutomationPathname = "/ai-automation";
const contractingPathname = "/nexus/contracting";
const nexusterms = "/nexus/terms";
const clientServicesAgreement = "/nexus/csa";
const statementOfWork = "/nexus/sow";
const consultation = "/nexus";
const companyLogo =
  "https://res.cloudinary.com/dhdccvkyt/image/upload/v1741884884/fusion/general-images/wiingr_vq0sam.png";

export {
  aiAutomationPathname,
  clientServicesAgreement,
  companyLogo,
  consultation,
  contractingPathname,
  hirePathname,
  langgraphPathname,
  mobileMaxWidth,
  nexusterms,
  portfolioPathname,
  ragPathname,
  statementOfWork,
};
